import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";
import { Observable } from "rxjs";
import { ResponsePackage } from "../models/util.model";
import { UploadFileInfo } from "../models/uploadFileInfo.model";

@Injectable({
  providedIn: 'root'
})
export class UploadFileInfoService {

  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'uploadFileInfo/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });


  getByType(type: any): Observable<any> {
    return this.http.post<ResponsePackage<UploadFileInfo[]>>(`${this.pathApi}getByType`, type);
  }


}